export const QUESTION_TYPE = 'questionType';
export const QUIZ_TYPE = 'quizType';
export const QUESTION_INTRODUCTION = 'introText';
export const QUESTION_PROMPT = 'prompt';
export const TOTAL_ANSWERS_TO_DISPLAY = 'totalAnswersToSelect';
export const MINIMUM_CORRECT_ANSWERS_TO_SELECT = 'minimumCorrectAnswersToSelect';
export const TYPE_OF_REQUIRED_ANSWER = 'requiredAnswerType';
export const VARIATIONS = 'quizQuestionVariations';
export const VARIATION_CONTENT = 'quizContent';
export const VARIATION_CONTENT_TYPE = 'quizContentType';

export const ANSWERS = 'quizAnswers';
export const ANSWER_IS_CORRECT = 'isCorrect';
export const ANSWER_TEXT = 'text';

export const CORRECT_FEEDBACK = 'correctFeedback';
export const PARTIALLY_CORRECT_FEEDBACK = 'partiallyCorrectFeedback';
export const WRONG_FEEBACK = 'wrongFeedback';

export const QUESTION_TYPES = {
    MULTIPLE: 'multiple',
} as const;

export const QUIZ_TYPES = {
    PRACTICE: 'practice',
    FINAL: 'final',
} as const;

export const REQUIRED_ANSWER_TYPES = {
    RANDOM: 'random',
    CORRECT: 'correct',
    WRONG: 'wrong',
} as const;

export const QUIZ_CONTENT_TYPES = {
    TEXT: 'text',
    AUDIO: 'audio',
    VIDEO: 'video',
    IMAGE: 'image',
    ARRANGE: 'arrange',
} as const;

export const ITEM_QUIZ_QUESTION_ENTITY_TYPE = 'ItemQuizQuestion' as const;
export const ITEM_QUIZ_ANSWER_ENTITY_TYPE = 'QuizAnswer' as const;
export const ITEM_QUIZ_QUESTION_CONTENT_ENTITY_TYPE = 'QuizQuestionContentJSONB' as const;

export const ELEMENT_QUIZ_VALIDATION_FIELDS_NAMES = {
    // only backend validation fields
    INTRO_TEXT: 'IntroText',
    QUESTION_PROMPT: 'OutroText',
    QUIZ_ANSWER_TEXT: 'Text',
    QUIZ_CONTENT: 'QuizContent',

    CORRECT_FEEDBACK: 'CorrectFeedback',
    PARTIALLY_CORRECT_FEEDBACK: 'PartiallyCorrectFeedback',
    WRONG_FEEDBACK: 'WrongFeedback',
} as const;
